/**
 * Chart palette.
 *
 * There is no charting library in this app — the visualisations are hand-rolled
 * SVG — so series colours come from the same design-token CSS variables the rest
 * of the UI uses, and therefore follow the light/dark theme automatically.
 */

export const SERIES_COLORS = [
  'var(--color-primary-500)',
  'var(--color-info-500)',
  'var(--color-success-500)',
  'var(--color-warning-500)',
  'var(--color-secondary-500)',
  'var(--color-error-500)',
  'var(--color-primary-300)',
  'var(--color-info-300)',
];

export const OTHER_COLOR = 'var(--color-neutral-400)';

/** Stable colour for a slice; the folded-tail "Other" slice is always neutral. */
export function colorForIndex(index: number, key?: string): string {
  if (key === '__other__') return OTHER_COLOR;
  return SERIES_COLORS[index % SERIES_COLORS.length];
}
